import { render, staticRenderFns } from "./TemplatesNavigationItem.vue?vue&type=template&id=0962df9a&scoped=true&"
import script from "./TemplatesNavigationItem.vue?vue&type=script&lang=js&"
export * from "./TemplatesNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesNavigationItem.vue?vue&type=style&index=0&id=0962df9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962df9a",
  null
  
)

export default component.exports